/** Shared helpers for the kiosk on-screen keyboard. */

/** True when the event target is on the docked kiosk keyboard chrome. */
export function isInsideKioskVirtualKeyboard(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false
  return Boolean(target.closest('[data-kiosk-vk-root]'))
}
